import React, { Component } from 'react'
import { Button, ButtonToolbar, Row, Col, Modal } from 'react-bootstrap'
import NkaCheckbox from 'nka-checkbox'

let maalerGattRundt = false
export default class InfoMaalerstandModal extends Component {
    constructor(props) {
        super(props)


        this._submit = this._submit.bind(this)
        this._handleMaalerGattrundt = this._handleMaalerGattrundt.bind(this)
    }


    _handleMaalerGattrundt(event) {
        maalerGattRundt = event.target.checked      
    }

    _submit() {        
        this.props.standErOk(maalerGattRundt)
    }


    render() {
        return (
            <Modal show={this.props.isOpen} onHide={this.props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Unaturlig lav stand</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <Row>
                        <Col sm={12}>
                            <p>Ny stand {this.props.stand} er mindre enn forrige stand {this.props.forrigeStand} (årsavlesning).</p>                            
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <NkaCheckbox onChange={this._handleMaalerGattrundt} style={{marginTop: 5+'px' , marginBottom: 10+'px', paddingBottom: 10+'px' }}>
                                Måler har gått rundt
                            </NkaCheckbox>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12}>                          
                            <p> Er du sikker på du har skrevet riktig?</p>
                        </Col>
                    </Row>
                    <ButtonToolbar>
                        <Button bsStyle="primary" onClick={this._submit}>Ja</Button>
                        <Button onClick={this.props.onClose}>Nei</Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/utskiftning/vannmaalere/infomaalerstandmodal.jsx